export function buildQueryString(params: any): string {
  let queryString = '';
  if (Object.keys(params).length !== 0 && params.constructor === Object) {
    let tempArray: Array<string> = Object.keys(params).reduce((q, key) => {
      q.push(`${key}=${params[key]}`);
      return q;
    }, []);
    queryString = '?' + tempArray.join('&');
  }

  return queryString;
}
